module.exports = __webpack_public_path__ + "static/img/dialog-bg.8f5edf8a.png";